export default "__VITE_ASSET__3241caa9__"